const SubTitle = ({
  src,
  title,
  eng,
}: {
  src: string;
  title: string;
  eng: string;
}) => {
  return (
    <div className="relative w-full h-full mx-auto">
      <div className=" relative w-full h-fit text-white pb-7 pt-10 lg:py-14">
        <img
          src={src}
          alt={`${title} 페이지 상단 배경`}
          className="absolute left-0 top-0 w-full h-full"
        />
        <div id="title" className="relative w-full h-fit text-center">
          <h3 className="font-medium lg:text-3xl">{title}</h3>
          <p className="text-point pt-1">- {eng} -</p>
          <div className="relative w-fit h-fit mx-auto">
            <img
              alt="카이노스 바이오케미칼 로고"
              className="!relative w-auto h-full object-contain max-h-20 lg:max-h-32"
              src="/images/subLogo.webp"
              width={596}
              height={207}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubTitle;
